import Dispatch from "./client";

const urls = {
  userInfo: {
    url: "/user/info",
    method: "get",
  },
  changePassword: {
    url: "/user/change-password",
    method: "post",
  },
  resetPassword: {
		url: '/user/reset-password',
		method: 'post'
	},
  allUsers: {
    url: "/user/all-users",
    method: "get",
  },
  searchUsers: {
    url: "/user/search-users",
    method: "get",
  },
  deleteUserDevice: {
    url: "/user/delete-device",
    method: "delete",
  },
  deleteUser : {
    url : "/user/deleteData",
    method : "post"
  },
	updateUser : {
    url : "/user/update-user-info",
    method : "patch"
  },
	updateAvatar: {
		url: '/user/update-avatar',
		method: 'patch'
	},
	deleteAvatar: {
		url: '/user/delete-avatar',
		method: 'delete'
	},
  // New analytics endpoints
  getUserAnalytics: {
    url: "/user/analytics",
    method: "get",
  },
  getAdvancedUserSearch: {
    url: "/user/advanced-search",
    method: "post",
  },
  getUsersWithoutDrive: {
    url: "/user/without-drive",
    method: "get",
  },
  getUsersWithSharedDrive: {
    url: "/user/with-shared-drive",
    method: "get",
  },
  getGeographicAnalytics: {
    url: "/user/geographic-analytics",
    method: "get",
  },
  getDeviceAnalytics: {
    url: "/device/analytics",
    method: "get",
  },
  getAdvancedDeviceSearch: {
    url: "/device/advanced-search",
    method: "post",
  }
};

function api() {
  return {
    getUserInfo: (data) => Dispatch(urls.userInfo, data.params, data.payload, data.options),
    changeUserPassword: (data) => Dispatch(urls.changePassword, data.params, data.payload, data.options),
    getUsers: (data) => Dispatch(urls.allUsers, data.params, data.payload, data.options),
    getFilteredUsers: (data) =>
      Dispatch(urls.searchUsers, data.params, data.payload, data.options),
    deleteUserDevice: (data) =>
      Dispatch(urls.deleteUserDevice, data.params, data.payload, data.options),
    deleteUser : (data) => Dispatch(urls.deleteUser , data.params , data.payload, data.options),
		resetPassword: data => Dispatch(urls.resetPassword, data.params, data.payload, data.options),
		updateUser: data => Dispatch(urls.updateUser, data.params, data.payload, data.options),
		updateAvatar: data => Dispatch(urls.updateAvatar, data.params, data.payload, data.options),
		deleteAvatar: data => Dispatch(urls.deleteAvatar, data.params, data.payload, data.options),
    // New analytics API methods
    getUserAnalytics: (data) => Dispatch(urls.getUserAnalytics, data.params, data.payload, data.options),
    getAdvancedUserSearch: (data) => Dispatch(urls.getAdvancedUserSearch, data.params, data.payload, data.options),
    getUsersWithoutDrive: (data) => Dispatch(urls.getUsersWithoutDrive, data.params, data.payload, data.options),
    getUsersWithSharedDrive: (data) => Dispatch(urls.getUsersWithSharedDrive, data.params, data.payload, data.options),
    getGeographicAnalytics: (data) => Dispatch(urls.getGeographicAnalytics, data.params, data.payload, data.options),
    getDeviceAnalytics: (data) => Dispatch(urls.getDeviceAnalytics, data.params, data.payload, data.options),
    getAdvancedDeviceSearch: (data) => Dispatch(urls.getAdvancedDeviceSearch, data.params, data.payload, data.options)
  };
    
}

export default api();
